import '~/init/turbo.js';
import '~/controllers/index.js';
import '~/init/lucide.js';

// eslint-disable-next-line no-console
console.log('Vite ⚡️ Rails');
